import {
  setJobEditPopupIframeLoading,
  setJobEditPopupIframeWaiting,
  setJobEditPopupIframeWaitingReceipt,
  setJobEditPopupInfo
} from "./jobEditActions";
import {parseJobResponse} from "./jobIframeParseVisualizerInfo";
import {uploadJobFileRequest} from "../../../actions/A_Calendar";
import {JOB_DOCUMENT_TYPES} from "../../../utilities/constants";
import {updateJob} from "../JobBoardActions";
import {getParsedJobOrder} from "../jobPurchaseOrderPopup/jobOrderFunctions";
import {updateJobOrder} from "../jobPurchaseOrderPopup/jobOrderApi";
import {setJobPurchaseOrderPopupStep} from "../jobPurchaseOrderPopup/jobPurchaseOrderActions";
import {store} from "../../../main";

export const DASHBOARD_MESSAGING_ACTIONS = {
  updateCartItems: "updateCartItems", // parent -> visualizer
  setCostPrices: "setCostPrices", // parent -> visualizer
  setReferralData: "setReferralData", // parent -> visualizer
  jobDataAfterUpdate: "jobDataAfterUpdate", // visualizer -> parent
}

export const sendIframePostMessage = (iframeElement, message) => {
  if (iframeElement && iframeElement.contentWindow && iframeElement.contentWindow.postMessage) {
    iframeElement.contentWindow.postMessage(message, iframeElement.src);
  }
}

export const listenToDashboardMessaging = async (event, dispatch, job, intl) => {
  if (!event || !event.data || !event.data.action) {
    return
  }
  switch (event.data.action) {
    case DASHBOARD_MESSAGING_ACTIONS.jobDataAfterUpdate: {
      if (event.data.payload && +event.data.payload.jobId === job.id) {
        const parsedJobData = parseJobResponse(event.data.payload.jobData, intl);
        console.log("jobDataAfterUpdate allData & parsedJobData", event.data.payload.jobData, parsedJobData);
        dispatch(setJobEditPopupInfo(parsedJobData));
        dispatch(setJobEditPopupIframeLoading(false));
        dispatch(setJobEditPopupIframeWaiting(false));
        if (event.data.payload.receiptBlob) {
          await uploadDocumentAndFinishLoading(event.data.payload.receiptBlob, job, dispatch);
        }
      }
      // main logic here
      break;
    }
    default:
      break;
  }
}

const uploadDocumentAndFinishLoading = async (receiptBlob, job, dispatch) => {
  const responseUploadJobFile = await uploadJobFileRequest(receiptBlob, job, JOB_DOCUMENT_TYPES.order);
  if (responseUploadJobFile && responseUploadJobFile.downloadUrl) {
    const {purchaseOrderStep} = store.getState().jobPurchaseOrderPopupState;
    const jobOrder = getParsedJobOrder(job); // jobOrderInterface
    jobOrder.orderFileUrl = responseUploadJobFile.downloadUrl;
    dispatch(updateJob(job, {
      jobOrder: JSON.stringify(jobOrder),
    }));
    const updated = await dispatch(updateJobOrder(jobOrder));
    dispatch(setJobPurchaseOrderPopupStep(updated ? purchaseOrderStep + 1 : purchaseOrderStep + 2));
    dispatch(setJobEditPopupIframeWaitingReceipt(false));
  }
}
